var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.71558C6 6.40187 8.68629 3.71558 12 3.71558C15.3137 3.71558 18 6.40187 18 9.71558C18 13.0293 15.3137 15.7156 12 15.7156C8.68629 15.7156 6 13.0293 6 9.71558ZM12 1.71558C7.58172 1.71558 4 5.2973 4 9.71558C4 12.6471 5.57682 15.2104 7.92858 16.6035L7.01165 22.5635C6.9548 22.9331 7.10884 23.3034 7.41096 23.5237C7.71309 23.7439 8.11283 23.7772 8.44724 23.61L12 21.8336L15.5528 23.61C15.8872 23.7772 16.287 23.7439 16.5891 23.5237C16.8912 23.3034 17.0452 22.9331 16.9884 22.5635L16.0715 16.6035C18.4232 15.2104 20 12.6471 20 9.71558C20 5.2973 16.4183 1.71558 12 1.71558ZM14.1731 17.4169C13.4821 17.6115 12.7532 17.7156 12 17.7156C11.2468 17.7156 10.5179 17.6115 9.82697 17.4169L9.28244 20.9564L11.5528 19.8212C11.8343 19.6804 12.1657 19.6804 12.4472 19.8212L14.7176 20.9564L14.1731 17.4169Z",
    fill: "#E87663"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificationIcon);
export default __webpack_public_path__ + "static/media/certification-icon.ec29cece6ad263ea3172ea5d9e05f9cd.svg";
export { ForwardRef as ReactComponent };